import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useTransitionStyles } from './TransitionSection.styles';
import TransitionVisual from './TransitionVisual';
import { fadeUp, viewportOnce } from '../../../../styles/animations';

const TransitionSection = () => {
    const { classes } = useTransitionStyles();

    return (
        <Box component="section" className={classes.section}>
            <Box className={classes.inner}>
                <motion.div initial="hidden" whileInView="visible" viewport={viewportOnce} variants={fadeUp}>
                    <Typography variant="overline" className={classes.eyebrow}>How we work</Typography>
                    <Typography variant="display2" component="h2" className={classes.headline}>
                        From strategy<br />to software.
                    </Typography>
                </motion.div>

                <Box className={classes.visual}>
                    <TransitionVisual />
                </Box>
            </Box>
        </Box>
    );
};

export default TransitionSection;
